/**
 * widgets/register.ts — Spec → Def. Orazítkuje povinná pole (since/updated) a
 * doplní odvozená (kind/formats), takže registrovaný widget má vždy kompletní
 * mandatory kontrakt (kontinuita garantovaná typem, ne konvencí).
 */
import type { WidgetDef, WidgetFormat, WidgetSpec } from './types';

const DEFAULT_FORMATS: Record<string, WidgetFormat[]> = {
  stat: ['sm', 'md'],
  list: ['md', 'lg'],
  chart: ['md', 'lg'],
  custom: ['sm', 'md', 'lg'],
};

/** Orazítkuje kolekci speců na kompletní WidgetDef. `build` = datum této dávky. */
export function registerWidgets(
  specs: WidgetSpec[],
  meta: { since: string; build: string },
): WidgetDef[] {
  return specs.map((s) => {
    const kind = s.kind ?? 'custom';
    return {
      ...s,
      kind,
      formats: s.formats ?? DEFAULT_FORMATS[kind] ?? ['sm', 'md', 'lg'],
      since: s.since ?? meta.since,
      updated: s.updated ?? meta.build,
    };
  });
}
